// Minimal JavaScript for bullet navigation
function initCarousel() {
  const carousel = document.getElementById('featured-articles-grid');
  const bulletsEl = document.getElementById('featured-articles__bullets');
  const bullets = bulletsEl.querySelectorAll('.featured-articles__bullet');
  let currentSlide = 0;

  // Only enable carousel functionality on mobile
  function updateCarousel() {
    if (window.innerWidth <= 749) {
      const containerWidth = carousel.parentElement.offsetWidth;
      const slideWidth = carousel.children[0].offsetWidth;
      const gap = 16;
      const totalSlides = bullets.length;

      let translateX;

      if (currentSlide === totalSlides - 1) {
        // Last slide: snap to right edge
        const totalContentWidth = (slideWidth + gap) * totalSlides - gap;
        translateX = totalContentWidth - containerWidth + 10; // 10px padding
      } else {
        // Other slides: snap to left edge
        translateX = currentSlide * (slideWidth + gap);
      }

      carousel.style.transform = `translateX(-${translateX}px)`;

      bullets.forEach((bullet, index) => {
        bullet.classList.toggle('active', index === currentSlide);
      });
    }
  }

  // Bullet click handlers
  bullets.forEach((bullet, index) => {
    bullet.addEventListener('click', () => {
      if (window.innerWidth <= 749) {
        currentSlide = index;
        updateCarousel();
      }
    });
  });

  // Handle window resize
  window.addEventListener('resize', () => {
    if (window.innerWidth > 749) {
      carousel.style.transform = 'none';
      currentSlide = 0;
      bullets[0].classList.add('active');
      bullets.forEach((bullet, index) => {
        if (index > 0) bullet.classList.remove('active');
      });
    } else {
      updateCarousel();
    }
  });

  // Optional: Touch/swipe support (still minimal JS)
  let startX = 0;
  let isDragging = false;

  carousel.addEventListener('touchstart', (e) => {
    if (window.innerWidth <= 749) {
      startX = e.touches[0].clientX;
      isDragging = true;
    }
  });

  carousel.addEventListener('touchend', (e) => {
    if (!isDragging || window.innerWidth > 749) return;

    const endX = e.changedTouches[0].clientX;
    const diffX = startX - endX;

    if (Math.abs(diffX) > 50) {
      // Minimum swipe distance
      if (diffX > 0 && currentSlide < bullets.length - 1) {
        currentSlide++;
      } else if (diffX < 0 && currentSlide > 0) {
        currentSlide--;
      }
      updateCarousel();
    }
    isDragging = false;
  });

  // Initial setup
  updateCarousel();
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', initCarousel);
